import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  fields: {
    '& .MuiBox-root': {
      marginBottom: theme.spacing(2),
    },
  },
}))

export default useStyles
